// extracted by mini-css-extract-plugin
export var blue = "_1p-f";
export var brand = "_1p-b";
export var darkGrey = "_1p-e";
export var disabled = "_1p-4";
export var disabledSubtle = "_1p-5";
export var error = "_1p-6";
export var green = "_1p-g";
export var grey = "_1p-d";
export var icon = "_1p-0";
export var inherit = "_1p-a";
export var lightGrey = "_1p-c";
export var orange = "_1p-i";
export var pink = "_1p-k";
export var primary = "_1p-1";
export var purple = "_1p-l";
export var red = "_1p-j";
export var secondary = "_1p-2";
export var success = "_1p-9";
export var tertiary = "_1p-3";
export var warning = "_1p-7";
export var warningSecondary = "_1p-8";
export var white = "_1p-m";
export var yellow = "_1p-h";